var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import jwt from 'jsonwebtoken';
import { decode } from './base64.js';
export default (token, encodedRSAKey, _a = {}) => {
    var { ignoreExpiration = true } = _a, rest = __rest(_a, ["ignoreExpiration"]);
    if (!token)
        return {};
    try {
        return jwt.verify(token, decode(encodedRSAKey), Object.assign({ ignoreExpiration }, rest));
    }
    catch (err) {
        console.log('Failed JWT validation: ', err, jwt.decode(token));
        return {};
    }
};
//# sourceMappingURL=validate-jwt.js.map